import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import DesktopNavigation from "./DesktopNavigation"
import MobileNavigation from "./MobileNavigation"
import { useLocation } from "@reach/router"
import Logo from "@elements/Logo"
import throttle from "lodash-es/debounce"
import { motion } from "framer-motion"
import { useStateContext } from "@context/stateContext"
import tw, { styled } from "twin.macro"

const isBrowser = () => typeof window !== "undefined"

function LeadFormNavBar() {
  return (
    <>
      <div
        className={`z-40 flex  items-center bg-white px-offset md:px-offsetMd lg:px-10 2xl:px-c80 fhd:px-c100 xl:px-24 fixed w-full shadow-xl`}
      >
        <div
          className="relative z-10 flex items-center self-start h-20 md:h-24"
          title="Hattenberger Partner"
        >
          <Logo className="object-contain w-auto h-16 md:h-24" />
        </div>
      </div>
    </>
  )
}

function DefaultNavBar() {
  const { isMobile, setNavbarHovered, unsetNavbarHovered } = useStateContext()

  const location = useLocation()
  const locationPathName = location.pathname

  // const [navBarHovered, setNavBarHovered] = useState()

  const [pageScrolled, setPageScrolled] = useState(
    locationPathName !== "/" ? true : false
  )
  const handelMenuVisibility = event => {
    setPageScrolled(window.scrollY ? true : false)
  }
  useEffect(() => {
    if (locationPathName !== "/") {
      setPageScrolled(true)
    } else {
      setPageScrolled(window.scrollY ? true : false)
    }
    handelMenuVisibility()
  }, [locationPathName])
  const onWindowScroll = throttle(handelMenuVisibility, 50, {
    trailing: true,
    leading: true,
  })
  useEffect(() => {
    isBrowser() && window.addEventListener("scroll", onWindowScroll.bind(this))
    return () =>
      isBrowser() && window.removeEventListener("scroll", onWindowScroll)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Filter out all menue items that have a parent item
  const data = useStaticQuery(graphql`
    query MainMenu {
      wpMenu(slug: { eq: "mega-menu" }) {
        id
        menuItems {
          nodes {
            label
            path
            id
            parentId
            acfMegaMenu {
              columns {
                items {
                  menuTitle
                  menuItem {
                    ... on WpPage {
                      link
                      id
                      title
                    }
                    ... on WpReferenz {
                      link
                      id
                      title
                    }
                    ... on WpHowTo {
                      link
                      id
                      title
                    }
                    ... on WpJob {
                      link
                      id
                      title
                    }
                  }
                  subitems {
                    submenuItem {
                      ... on WpPage {
                        link
                        id
                        title
                      }
                      ... on WpReferenz {
                        link
                        id
                        title
                      }
                      ... on WpHowTo {
                        link
                        id
                        title
                      }
                      ... on WpJob {
                        link
                        id
                        title
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const menuItems = data.wpMenu.menuItems.nodes.filter(
    menuItem =>
      menuItem.parentId === null &&
      menuItem.label.toLowerCase() === "referenzen"
  )
  return (
    <>
      {/* <div
        className={`z-50 fixed w-full h-[32px] px-offset md:px-offsetMd items-center lg:px-16  xl:px-24 flex justify-end justify-items-center text-base lg:text-lg bg-black text-yellow font-bold`}
      >
        <a
          className={`flex items-baseline font-ubuntu`}
          target="_blank"
          rel="noopener"
          href={`https://schmitts-katze.de`}
          title={`Zu den Bannerangeboten`}
          aria-label={`Zu den Bannerangeboten`}
        >
          <span>Zu den Bannerangeboten</span>
          <span className={`font-firacode leading-none`}>|-&gt;</span>
        </a>
      </div> */}
      {typeof window !== "undefined" && isMobile && (
        <div
          className={`z-50 flex justify-between items-center px-offset md:px-offsetMd xl:px-24 top-0 h-20 md:h-24 fixed w-full bg-white 
          ${pageScrolled ? "shadow-xl" : ""} transition-shadow duration-700`}
        >
          <Link
            className="absolute flex items-center self-start h-20 md:h-24 xl:h-64"
            to={`/`}
          >
            <Logo className="object-contain w-auto h-16 md:h-24 xl:h-64" />
          </Link>
          {/* <MobileNavigation menuItems={menuItems} /> */}
        </div>
      )}
      {typeof window !== "undefined" && !isMobile && (
        <MainNaviBar
          onMouseEnter={() => setNavbarHovered()}
          onMouseLeave={() => unsetNavbarHovered()}
          className={`z-40 flex justify-between items-center bg-white px-offset md:px-offsetMd lg:px-10 2xl:px-c80 fhd:px-c100 xl:px-24 top-0 fixed w-full ${
            pageScrolled ? "shadow-xl" : ""
          } transition-shadow transition-colors duration-400`}
        >
          <MotionLink
            className="relative z-10  w-20 h-20 md:h-20 md:w-20 lg:w-full lg:max-w-36 3xl:max-w-48 lg:h-auto origin-logo2030 lg:origin-logo5030 2xl:origin-logo2030"
            to={`/`}
            animate={pageScrolled ? "small" : "big"}
            variants={desktopLogoVariants}
            initial={desktopLogoVariants.big}
            title="Hattenberger Partner"
            transformTemplate={(_, transform) =>
              transform.replace("translateZ(0)", "")
            }
          >
            <Logo className="object-contain w-auto" />
          </MotionLink>
          {/* <DesktopNavigation
            menuItems={menuItems}
            pageScrolled={pageScrolled}
            // navBarHovered={navBarHovered}
          /> */}
        </MainNaviBar>
      )}
    </>
  )
}

function NavBar({ isLeadForm }) {
  if (isLeadForm) {
    return <LeadFormNavBar />
  }
  return <DefaultNavBar />
}

const MainNaviBar = styled.div`
  &:has(.level-0.open-true) {
    @media screen and (min-width: 1024px) {
      // border-bottom: 1px solid #0000FF;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #0000ff;
        z-index: 50;
      }
    }
  }
` 

export default NavBar

const MotionLink = motion(Link)

const desktopLogoVariants = {
  small: {
    paddingTop: "20px",
    paddingBottom: "20px",
    scale: 0.8,
  },
  big: {
    paddingTop: "50px",
    paddingBottom: "50px",
    scale: 1,
  },
}
